import { batch, untrack } from "solid-js"
import { createStore } from "solid-js/store"

const disposedResult = false

export function createProvisionalSessionController() {
  const [provisional, setProvisional] = createStore<Record<string, true | undefined>>({})
  const waiters = new Map<string, Set<(confirmed: boolean) => void>>()
  let disposed = false

  const settle = (sessionID: string, confirmed: boolean) => {
    if (!untrack(() => provisional[sessionID])) return
    const pending = waiters.get(sessionID)
    waiters.delete(sessionID)
    for (const resolve of pending ?? []) resolve(confirmed)
    setProvisional(sessionID, undefined)
  }

  return {
    add(sessionID: string) {
      if (!disposed) setProvisional(sessionID, true)
    },
    has(sessionID: string) {
      return provisional[sessionID] === true
    },
    settle,
    wait(sessionID: string) {
      if (disposed) return Promise.resolve(disposedResult)
      if (!untrack(() => provisional[sessionID])) return Promise.resolve(true)
      return new Promise<boolean>((resolve) => {
        const pending = waiters.get(sessionID)
        if (pending) pending.add(resolve)
        else waiters.set(sessionID, new Set([resolve]))
      })
    },
    dispose() {
      if (disposed) return
      disposed = true
      batch(() => {
        for (const sessionID of untrack(() => Object.keys(provisional))) settle(sessionID, disposedResult)
      })
      waiters.clear()
    },
  }
}
